export default "/images/vendor/flag-icons/flags/1x1/aw.svg?9f9a1e16047b82cc7ebe36c7baad656a";